import { generateTableSlice } from "./sliceTable";

const slicePatientTable = generateTableSlice("patient");

export const ActionsPatientTable = slicePatientTable.actions;
export const ReducerPatientTable = slicePatientTable.reducer;
